/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ b: NonNullable<unknown> }} Wood_ConsoInputs */



/**
* | output |
* | --- |
* | "Wood: {b} T" |
*
* @param {Wood_ConsoInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const wood_conso = /** @type {((inputs: Wood_ConsoInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wood_ConsoInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Wood: ${i?.b} T`)
	return /** @type {LocalizedString} */ (`Bois : ${i?.b} T`)
});